export var ProjectCommmitmentGenerationSource;
(function (ProjectCommmitmentGenerationSource) {
    ProjectCommmitmentGenerationSource["Framework"] = "framework";
    ProjectCommmitmentGenerationSource["Custom"] = "custom";
})(ProjectCommmitmentGenerationSource || (ProjectCommmitmentGenerationSource = {}));
